<template>
  <div :class="`w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik ${aboutUs ? 'pt-12 1240-bp:pt-28 1240-bp:pb-16' : 'get-in-touch-outer-container'}`">
    <div :class="`w-full ${aboutUs ? 'max-w-1024 mx-5' : 'max-w-1440 mx-5'}`">
      <div :class="`w-full flex flex-col gap-8 1240-bp:flex-row 1240-bp:gap-16`">
        <!-- MAP SECTION -->
        <div class="1240-bp:w-1/2 w-full border bg-white map-border-radius map-border-color">
          <div class="flex flex-col">
            <div class="w-full h-full get-in-touch-map-container">
              <google-maps :apiKey="googleMapsApiKey" class="google-map-border-radius" />
            </div>
            <div>
              <div :class="`flex flex-row justify-between items-center city-state-section ${aboutUs ? 'px-5 py-3 1240-bp:py-5 font-medium' : 'p-5 font-semibold'}`">
                <p>{{ city }}</p>
                <p>{{ state }}</p>
              </div>
              <div class="flex flex-row justify-between items-center h-12 open-map-section p-5">
                <button @click="openGoogleMaps" class="w-full flex flex-row justify-between items-center">
                  <p>Open on Maps</p>
                  <img class="svg-gray h-6" src="@/images/get-in-touch/open-map-arrow.svg" alt="Open map">
                </button>
              </div>
              <div class="flex flex-row justify-between items-center p-5">
                <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/solutions/container-modifications">
                  <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/modifications.svg" alt="Container modifications">
                  <p>Container</p>
                  <p>Modifications</p>
                </a>
                <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/containers-for-sale">
                  <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/sales.svg" alt="Container sales">
                  <p>Container</p>
                  <p>Sales</p>
                </a>
                <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/containers-for-rent">
                  <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/rental.svg" alt="Container rental">
                  <p>Container</p>
                  <p>Rental</p>
                </a>
                <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/solutions/refrigerated-containers">
                  <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/refrigerated.svg" alt="Refrigerated containers">
                  <p>Refrigerated</p>
                  <p>Containers</p>
                </a>
                <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/solutions/portable-offices">
                  <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/offices.svg" alt="Portable officies">
                  <p>Portable</p>
                  <p>Officies</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- GET IN TOUCH SECTION -->
        <div class="1240-bp:w-1/2 w-full">
      
          <div class="w-full flex flex-col justify-between h-full gap-4 1240-bp:gap-0">
            <div :class="`${aboutUs ? '1240-bp:mb-4' : ''}`">
              <h1 class="get-in-touch-h1">Get in touch </h1>
            </div>
            <div :class="`w-full flex flex-col justify-between gap-3 ${aboutUs ? '' : '1240-bp:flex-row'}`">
              <div class="flex flex-col w-full gap-2">
                <label class="get-in-touch-label" for="first_name">
                  First Name <span class="get-in-touch-required-field">*</span>
                </label>
                <input
                  class="get-in-touch-input min-w-full"
                  v-model="lead.firstName"
                  name="first_name"
                  id="first_name"
                  type="text"
                >
              </div>
              <div class="flex flex-col w-full gap-2">
                <label class="get-in-touch-label" for="last_name">
                  Last Name <span class="get-in-touch-required-field">*</span>
                </label>
                <input
                  class="get-in-touch-input min-w-full"
                  v-model="lead.lastName"
                  name="last_name"
                  id="last_name"
                  type="text"
                >
              </div>
            </div>
            <div :class="['w-full flex flex-col 1240-bp:flex-row justify-between gap-3', { '1240-bp:my-2': aboutUs }]" >
              <div class="flex flex-col w-full gap-2">
                <label class="get-in-touch-label" for="email">
                  Email <span class="get-in-touch-required-field">*</span>
                </label>
                <input
                  class="get-in-touch-input min-w-full"
                  v-model="lead.email"
                  name="email"
                  id="email"
                  type="email"
                >
              </div>
            </div>
            <div :class="`w-full flex flex-col justify-between gap-3 ${aboutUs ? '' : '1240-bp:flex-row'}`">
              <div class="flex flex-col w-full gap-2">
                <label class="get-in-touch-label" for="phone">
                  Phone <span class="get-in-touch-required-field">*</span>
                </label>
                <input
                  class="get-in-touch-input min-w-full"
                  v-model="lead.phone"
                  name="phone"
                  id="phone"
                  type="text"
                >
              </div>
              <div class="w-full flex flex-col gap-2 relative">
                <label class="get-in-touch-label" for="zipcode">
                  Zip Code <span class="get-in-touch-required-field">*</span>
                </label>
                <input
                  class="get-in-touch-input get-in-touch-zip-code min-w-full"
                  v-model="lead.zipcode"
                  name="zipcode"
                  id="zipcode"
                  type="text"
                >
                <img class="absolute left-3 pr-3 transform -translate-y-1/2 h-6" style="top: 70%;" src="@/images/get-in-touch/current-location.svg" alt="Zip code">
              </div>
            </div>
            <div :class="['w-full flex flex-col 1240-bp:flex-row justify-between gap-3', { '1240-bp:my-4': aboutUs }]" >
              <div class="flex flex-col w-full gap-2">
                <label class="get-in-touch-label" for="notes">Message (Optional)</label>
                <textarea
                  :class="`get-in-touch-input min-w-full ${aboutUs ? 'get-in-touch-textarea-about-us' : 'get-in-touch-textarea'}`"
                  v-model="lead.notes"
                  id="notes"
                  placeholder="Type your message..."
                >
                </textarea>
              </div>
            </div>
            <div class="w-full flex flex-col 1240-bp:flex-row justify-between gap-3">
              <div class="w-full 1240-bp:w-3/4 flex flex-row items-center">
                <input
                  class="get-in-touch-checkbox"
                  v-model="lead.smsConsent"
                  name="smsConsent"
                  id="smsConsent"
                  type="checkbox"
                >
                <label :class="`${aboutUs ? 'get-in-touch-consent' : 'get-in-touch-label'} pl-2 w-full`" for="smsConsent">
                  I consent to receive SMS text messages from this business.
                </label>
              </div>
              <div class="w-full 1240-bp:w-1/4 flex flex-row justify-center">
                <button
                  :class="[`${aboutUs ? 'about-us-get-in-touch-button': 'get-in-touch-button'} flex items-center justify-center gap-1`, isFormValid ? 'bg-themeButton' : 'bg-themeButton-light cursor-not-allowed']"
                  :disabled="!isFormValid"
                  @click="validateForm"
                >
                  <p>{{ buttonText }}</p>
                  <img class="h-5" v-if="buttonText == 'Message sent'"  src="@/images/get-in-touch/check-circle.svg">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leadForm from 'shared/mixins/lead-form'
import GoogleMaps from '../google-maps/index.vue'
import { graphqlQuery } from 'shared/graphql'
import { zipQuery } from 'shared/graphql/queries'


export default {
  mixins: [leadForm],
  components: {
    GoogleMaps
  },
  props: {
    googleMapsApiKey: {
      required: true,
      type: String
    },
    aboutUs: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      city: '-',
      state: '-',
      buttonText: 'Get a Quote'
    }
  },
  watch: {
    'lead.zipcode': function(newZipcode) {
      if (this.isValidZipcode(newZipcode)) {
        this.$bus.$emit('insertedZipcode', this.lead.zipcode)
        this.fetchCityState()
      }
    }
  },
  computed: {
    isFirstNameValid() {
      return this.lead.firstName.trim().length > 0
    },
    isLastNameValid() {
      return this.lead.lastName.trim().length > 0
    },
    isEmailValid() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailPattern.test(this.lead.email)
    },
    isPhoneValid() {
      const phoneDigits = this.lead.phone.replace(/\D/g, '')
      return phoneDigits.length >= 10
    },
    isZipcodeValid() {
      return this.isValidZipcode(this.lead.zipcode)
    },
    isFormValid() {
      return this.isFirstNameValid && this.isLastNameValid && this.isEmailValid && this.isPhoneValid && this.isZipcodeValid
    }
  },
  methods: {
    isValidZipcode(zipcode) {
      const zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/
      return zipCodePattern.test(zipcode)
    },
    async fetchCityState() {
      try {
        const response = await graphqlQuery({
          fetchPolicy: 'no-cache',
          query: zipQuery,
          variables: {
            id: this.lead.zipcode
          }
        })
        this.formatCityAndState(response.data.zipcode)
      } catch (error) {
        console.error('Error fetching zipcode:', error)
      } 
    },
    formatCityAndState(zipcodeData) {
      if (zipcodeData && zipcodeData.city && zipcodeData.city.id) {
        const [state, city] = zipcodeData.city.id.split('/')
        const formattedCity = city.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        this.city = formattedCity
        this.state =  state.toUpperCase()
      } else {
        return {
          city: '-',
          state: '-'
        }
      }
    },
    openGoogleMaps() {
      const address = `${this.city}, ${this.state} ${this.lead.zipcode}`
      const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
      window.open(url, '_blank')
    },
    validateForm() {
      if (this.isFormValid) {
        this.handleSubmit()
        this.updateButtonText()
      } else {
        console.error('Form is invalid')
      }
    },
    updateButtonText() {
      this.buttonText = 'Message sent'
      this.clearForm()
      setTimeout(() => {
        this.buttonText = 'Get in touch'
      }, 5000)
    },
    clearForm() {
      this.lead.firstName = ''
      this.lead.lastName = ''
      this.lead.email = ''
      this.lead.phone = ''
      this.lead.smsConsent = false
    }
  }
}
</script>

<style scoped>
.get-in-touch-outer-container {
  padding-top: 112px;
}

.get-in-touch-h1 {
  color: black;
  font-size: 32px;
  font-weight: 400;
  line-height: 38.4px;
  letter-spacing: -0.04em;
  text-align: left;
}

.map-border-color {
  border: 2px solid #CCCCCC; 
}

.map-border-radius {
  border-radius: 16px;
}

.google-map-border-radius {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.svg-gray {
  /* #666666 */
  filter: invert(40%) sepia(1%) saturate(0%) hue-rotate(168deg) brightness(94%) contrast(80%);
}

.map-links {
  color: #4a4a4a !important;
  font-size: 14px;
  font-weight: 400;
}

.about-us-map-links {
  color: #4a4a4a !important;
  font-size: 8px;
  font-weight: 400;
  line-height: 12px;
}

.terms-links {
  color: #4a4a4a !important;
}

.open-map-section {
  border-top: 2px solid #CCCCCC;
  border-bottom: 2px solid #CCCCCC;
  border-left: none;
  border-right: none;
  color: black;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
}

.city-state-section {
  color: black;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04em;
}

.get-in-touch-label {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  color: black;
}
.get-in-touch-consent {
  color: #334155;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

.get-in-touch-required-field {
  color: #FF0000;
  font-weight: 600;
  font-size: 16px;
}

.get-in-touch-input {
  width: 272px;
  height: 48px;
  border: 2px solid #EEECE9;
  border-radius: 10px;
  background: #FFFFFF;
  padding: 8px 12px 8px 12px;
  gap: 8px;
}

.get-in-touch-zip-code {
  padding-left: 38px;
}

.get-in-touch-textarea {
  height: 187px
}

.get-in-touch-textarea-about-us {
  height: 100px
}

.get-in-touch-checkbox {
  width: 22px; 
  height: 22px; 
  border-radius: 13px;
  border: 2px solid #EEECE9;
}

.get-in-touch-button { 
  width: 180px;
  height: 50px;
  padding: 8px 16px 8px 16px;
  border-radius: 999px;
}

.get-in-touch-button p { 
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: white;
}

.about-us-get-in-touch-button { 
  width: 327px;
  height: 40px;
  padding: 8px 12px 8px 12px;
  border-radius: 9999px;
  color: white;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
}

.get-in-touch-map-container {
  height: 471px;
}

/* mobile */
@media(max-width: 1240px) {
  .get-in-touch-outer-container {
    padding-top: 20px;
  }
  
  .map-links {
    font-size: 10px;
  }

  .get-in-touch-button {
    margin-top: 5px;
    width: 100%;
  }

  .get-in-touch-map-container {
    height: 200px;
  }
}
</style>
